const css = `.settings-page .branch-settings-card .p-divider {
  margin: 16px 0;
}
.settings-page .branch-settings-card .settings-branch-select {
  min-width: fit-content;
}
.settings-page .branch-settings-card .settings-branch-select .branch-select-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.settings-page .branch-settings-card .settings-branch-select .branch-select-container .p-dropdown {
  flex: 1;
}
.settings-page .branch-color-picker-field {
  display: flex;
  align-items: center;
  gap: 12px;
}
.settings-page .branch-color-picker-field .branch-color-label {
  font-size: var(--font-size-xs);
  color: var(--text-color-secondary);
  font-family: var(--font-family-mono);
}
.settings-page .reservation-hours-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.settings-page .reservation-hours-header .reservation-hours-title {
  margin: 0;
}
.settings-page .reservation-hours-header .copy-hours-button {
  color: var(--text-muted);
  padding: 0 8px;
  transition: all 0.2s ease;
  height: unset;
}
.settings-page .reservation-hours-header .copy-hours-button:hover {
  color: var(--text-muted);
  background-color: var(--surface-hover);
}
.settings-page .reservation-hours-title {
  margin-bottom: -12px;
}
.settings-page .closed-days-title {
  margin-top: 16px;
  margin-bottom: 12px;
}
.settings-page .holidays-selector-button {
  width: fit-content;
}
.settings-page .settings-skeleton .settings-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.settings-page .settings-skeleton .settings-section .business-hours-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  background-color: var(--surface-card);
  border-radius: var(--border-radius);
  border: 1px solid var(--surface-border);
}
.settings-page .settings-skeleton .settings-section .business-hours-skeleton .business-day-skeleton .time-range {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.settings-page .settings-skeleton .settings-section .business-hours-skeleton .business-day-skeleton .time-range:not(.settings-page .settings-skeleton .settings-section .business-hours-skeleton .business-day-skeleton .time-range:last-of-type) {
  margin-bottom: 8px;
}
.settings-page .settings-skeleton .settings-section .business-hours-skeleton .business-day-skeleton .time-range .time-range-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.settings-page .settings-skeleton .settings-section .business-hours-skeleton .business-day-skeleton .time-range .time-range-content .switch {
  align-self: center;
  text-transform: capitalize;
  width: 140px;
  min-width: 120px;
  border-radius: 60px;
}
.settings-page .settings-skeleton .settings-section .business-hours-skeleton .business-day-skeleton .time-range .time-range-content .time-input {
  margin: 0;
}
.settings-page .settings-skeleton .settings-section .holiday-chips-skeleton {
  margin-top: 16px;
}
.settings-page .settings-skeleton .p-skeleton {
  background-color: var(--surface-ground);
}
.settings-page .settings-skeleton .p-skeleton::after {
  background: linear-gradient(90deg, transparent, var(--shimmer), transparent);
}
.settings-page .settings-skeleton .p-skeleton.mb-2 {
  margin-bottom: 8px;
}
.settings-page .settings-skeleton .p-skeleton.mb-4 {
  margin-bottom: 16px;
}
.settings-page .org-email-inputgroup .p-inputtext {
  text-align: end;
}
.settings-page .org-email-settings-description {
  color: var(--text-muted);
  font-style: italic;
  margin: -16px 0 -8px;
}
.settings-page .email-settings-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.settings-page .email-settings-header h4 {
  margin: 0;
}
.settings-page .email-settings-header .p-button {
  color: var(--text-muted);
}
.settings-page .email-settings-header .p-button:hover {
  color: var(--text-muted);
}

.holidays-dialog {
  width: 90vw;
  max-width: 1200px;
}
.holidays-dialog .p-dialog-content {
  padding: 1rem;
  overflow-x: hidden;
}
.holidays-dialog .holidays-calendar-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}
.holidays-dialog .holidays-calendar-grid .month-calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.holidays-dialog .holidays-calendar-grid .month-calendar h5 {
  margin-bottom: 0.5rem;
  text-transform: capitalize;
  color: var(--text);
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar {
  width: 100%;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker {
  width: 100% !important;
  min-width: unset;
  padding: 0.5rem;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table {
  margin: 0;
  width: 100%;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table th {
  padding: 0.5rem 0;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td {
  padding: 0.25rem;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td.p-datepicker-other-month {
  visibility: hidden;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td > span {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td.p-highlight > span {
  background: var(--accent);
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker .p-datepicker-header {
  padding: 0.5rem;
  border: none;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker .p-datepicker-header .p-datepicker-prev,
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker .p-datepicker-header .p-datepicker-next {
  display: none;
}

@media (max-width: 768px) {
  .holidays-dialog {
    width: 100vw;
    height: 100vh;
    margin: 0;
  }
  .holidays-dialog .p-dialog-content {
    padding: 0.5rem;
  }
  .holidays-dialog .holidays-calendar-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td > span {
    width: 1.75rem;
    height: 1.75rem;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL1NldHRpbmdzIiwic291cmNlcyI6WyJTZXR0aW5ncy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVJO0VBQ0U7O0FBR0Y7RUFDRTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQU1SO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUlKO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBS047RUFDRTs7QUFFRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTs7QUFJQTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdFO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFOztBQU9WO0VBQ0U7O0FBSUo7RUFDRTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFNSjtFQUNFOztBQUlKO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFOztBQUVBO0VBQ0U7OztBQU1SO0VBQ0U7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFLTjtFQUNFO0VBQ0E7O0FBRUE7QUFBQTtFQUVFOzs7QUFTZDtFQUNFO0lBQ0U7SUFDQTtJQUNBOztFQUVBO0lBQ0U7O0VBR0Y7SUFDRTtJQUNBOztFQU1RO0lBQ0U7SUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5zZXR0aW5ncy1wYWdlIHtcbiAgLmJyYW5jaC1zZXR0aW5ncy1jYXJkIHtcbiAgICAucC1kaXZpZGVyIHtcbiAgICAgIG1hcmdpbjogMTZweCAwO1xuICAgIH1cblxuICAgIC5zZXR0aW5ncy1icmFuY2gtc2VsZWN0IHtcbiAgICAgIG1pbi13aWR0aDogZml0LWNvbnRlbnQ7XG5cbiAgICAgIC5icmFuY2gtc2VsZWN0LWNvbnRhaW5lciB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIGdhcDogOHB4O1xuXG4gICAgICAgIC5wLWRyb3Bkb3duIHtcbiAgICAgICAgICBmbGV4OiAxO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLmJyYW5jaC1jb2xvci1waWNrZXItZmllbGQge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBnYXA6IDEycHg7XG5cbiAgICAuYnJhbmNoLWNvbG9yLWxhYmVsIHtcbiAgICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLXhzKTtcbiAgICAgIGNvbG9yOiB2YXIoLS10ZXh0LWNvbG9yLXNlY29uZGFyeSk7XG4gICAgICBmb250LWZhbWlseTogdmFyKC0tZm9udC1mYW1pbHktbW9ubyk7XG4gICAgfVxuICB9XG5cbiAgLnJlc2VydmF0aW9uLWhvdXJzLWhlYWRlciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGdhcDogMTZweDtcblxuICAgIC5yZXNlcnZhdGlvbi1ob3Vycy10aXRsZSB7XG4gICAgICBtYXJnaW46IDA7XG4gICAgfVxuXG4gICAgLmNvcHktaG91cnMtYnV0dG9uIHtcbiAgICAgIGNvbG9yOiB2YXIoLS10ZXh0LW11dGVkKTtcbiAgICAgIHBhZGRpbmc6IDAgOHB4O1xuICAgICAgdHJhbnNpdGlvbjogYWxsIDAuMnMgZWFzZTtcbiAgICAgIGhlaWdodDogdW5zZXQ7XG5cbiAgICAgICY6aG92ZXIge1xuICAgICAgICBjb2xvcjogdmFyKC0tdGV4dC1tdXRlZCk7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1cmZhY2UtaG92ZXIpO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIC5yZXNlcnZhdGlvbi1ob3Vycy10aXRsZSB7XG4gICAgbWFyZ2luLWJvdHRvbTogLTEycHg7XG4gIH1cbiAgLmNsb3NlZC1kYXlzLXRpdGxlIHtcbiAgICBtYXJnaW4tdG9wOiAxNnB4O1xuICAgIG1hcmdpbi1ib3R0b206IDEycHg7XG4gIH1cblxuICAuaG9saWRheXMtc2VsZWN0b3ItYnV0dG9uIHtcbiAgICB3aWR0aDogZml0LWNvbnRlbnQ7XG4gIH1cblxuICAuc2V0dGluZ3Mtc2tlbGV0b24ge1xuICAgIC5zZXR0aW5ncy1zZWN0aW9uIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgZ2FwOiAyNHB4O1xuXG4gICAgICAuYnVzaW5lc3MtaG91cnMtc2tlbGV0b24ge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICBnYXA6IDE2cHg7XG4gICAgICAgIHBhZGRpbmc6IDI0cHg7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1cmZhY2UtY2FyZCk7XG4gICAgICAgIGJvcmRlci1yYWRpdXM6IHZhcigtLWJvcmRlci1yYWRpdXMpO1xuICAgICAgICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1zdXJmYWNlLWJvcmRlcik7XG5cbiAgICAgICAgLmJ1c2luZXNzLWRheS1za2VsZXRvbiB7XG4gICAgICAgICAgLnRpbWUtcmFuZ2Uge1xuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgICAgICBnYXA6IDhweDtcbiAgICAgICAgICAgIG1hcmdpbi1ib3R0b206IDE2cHg7XG5cbiAgICAgICAgICAgICY6bm90KCY6bGFzdC1vZi10eXBlKSB7XG4gICAgICAgICAgICAgIG1hcmdpbi1ib3R0b206IDhweDtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgLnRpbWUtcmFuZ2UtY29udGVudCB7XG4gICAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgICAgICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgICAgICAgIGdhcDogMTZweDtcblxuICAgICAgICAgICAgICAuc3dpdGNoIHtcbiAgICAgICAgICAgICAgICBhbGlnbi1zZWxmOiBjZW50ZXI7XG4gICAgICAgICAgICAgICAgdGV4dC10cmFuc2Zvcm06IGNhcGl0YWxpemU7XG4gICAgICAgICAgICAgICAgd2lkdGg6IDE0MHB4O1xuICAgICAgICAgICAgICAgIG1pbi13aWR0aDogMTIwcHg7XG4gICAgICAgICAgICAgICAgYm9yZGVyLXJhZGl1czogNjBweDtcbiAgICAgICAgICAgICAgfVxuXG4gICAgICAgICAgICAgIC50aW1lLWlucHV0IHtcbiAgICAgICAgICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLmhvbGlkYXktY2hpcHMtc2tlbGV0b24ge1xuICAgICAgICBtYXJnaW4tdG9wOiAxNnB4O1xuICAgICAgfVxuICAgIH1cblxuICAgIC5wLXNrZWxldG9uIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1cmZhY2UtZ3JvdW5kKTtcblxuICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQoOTBkZWcsIHRyYW5zcGFyZW50LCB2YXIoLS1zaGltbWVyKSwgdHJhbnNwYXJlbnQpO1xuICAgICAgfVxuXG4gICAgICAmLm1iLTIge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gICAgICB9XG5cbiAgICAgICYubWItNCB7XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDE2cHg7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLm9yZy1lbWFpbC1pbnB1dGdyb3VwIHtcbiAgICAucC1pbnB1dHRleHQge1xuICAgICAgdGV4dC1hbGlnbjogZW5kO1xuICAgIH1cbiAgfVxuXG4gIC5vcmctZW1haWwtc2V0dGluZ3MtZGVzY3JpcHRpb24ge1xuICAgIGNvbG9yOiB2YXIoLS10ZXh0LW11dGVkKTtcbiAgICBmb250LXN0eWxlOiBpdGFsaWM7XG4gICAgbWFyZ2luOiAtMTZweCAwIC04cHg7XG4gIH1cblxuICAuZW1haWwtc2V0dGluZ3MtaGVhZGVyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgZ2FwOiAxNnB4O1xuICAgIG1hcmdpbi1ib3R0b206IDI0cHg7XG5cbiAgICBoNCB7XG4gICAgICBtYXJnaW46IDA7XG4gICAgfVxuXG4gICAgLnAtYnV0dG9uIHtcbiAgICAgIGNvbG9yOiB2YXIoLS10ZXh0LW11dGVkKTtcblxuICAgICAgJjpob3ZlciB7XG4gICAgICAgIGNvbG9yOiB2YXIoLS10ZXh0LW11dGVkKTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLmhvbGlkYXlzLWRpYWxvZyB7XG4gIHdpZHRoOiA5MHZ3O1xuICBtYXgtd2lkdGg6IDEyMDBweDtcblxuICAucC1kaWFsb2ctY29udGVudCB7XG4gICAgcGFkZGluZzogMXJlbTtcbiAgICBvdmVyZmxvdy14OiBoaWRkZW47IC8vIFByZXZlbmlyIHNjcm9sbCBob3Jpem9udGFsXG4gIH1cblxuICAuaG9saWRheXMtY2FsZW5kYXItZ3JpZCB7XG4gICAgZGlzcGxheTogZ3JpZDtcbiAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdChhdXRvLWZpdCwgbWlubWF4KDI1MHB4LCAxZnIpKTtcbiAgICBnYXA6IDEuNXJlbTtcblxuICAgIC5tb250aC1jYWxlbmRhciB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5cbiAgICAgIGg1IHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMC41cmVtO1xuICAgICAgICB0ZXh0LXRyYW5zZm9ybTogY2FwaXRhbGl6ZTtcbiAgICAgICAgY29sb3I6IHZhcigtLXRleHQpO1xuICAgICAgfVxuXG4gICAgICAuaG9saWRheS1jYWxlbmRhciB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuXG4gICAgICAgIC5wLWRhdGVwaWNrZXIge1xuICAgICAgICAgIHdpZHRoOiAxMDAlICFpbXBvcnRhbnQ7XG4gICAgICAgICAgbWluLXdpZHRoOiB1bnNldDtcbiAgICAgICAgICBwYWRkaW5nOiAwLjVyZW07XG5cbiAgICAgICAgICB0YWJsZSB7XG4gICAgICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcblxuICAgICAgICAgICAgdGgge1xuICAgICAgICAgICAgICBwYWRkaW5nOiAwLjVyZW0gMDtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgdGQge1xuICAgICAgICAgICAgICBwYWRkaW5nOiAwLjI1cmVtO1xuXG4gICAgICAgICAgICAgICYucC1kYXRlcGlja2VyLW90aGVyLW1vbnRoIHtcbiAgICAgICAgICAgICAgICB2aXNpYmlsaXR5OiBoaWRkZW47XG4gICAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgICA+IHNwYW4ge1xuICAgICAgICAgICAgICAgIHdpZHRoOiAycmVtO1xuICAgICAgICAgICAgICAgIGhlaWdodDogMnJlbTtcbiAgICAgICAgICAgICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgICAgICAgICB9XG5cbiAgICAgICAgICAgICAgJi5wLWhpZ2hsaWdodCA+IHNwYW4ge1xuICAgICAgICAgICAgICAgIGJhY2tncm91bmQ6IHZhcigtLWFjY2VudCk7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG5cbiAgICAgICAgICAucC1kYXRlcGlja2VyLWhlYWRlciB7XG4gICAgICAgICAgICBwYWRkaW5nOiAwLjVyZW07XG4gICAgICAgICAgICBib3JkZXI6IG5vbmU7XG5cbiAgICAgICAgICAgIC5wLWRhdGVwaWNrZXItcHJldixcbiAgICAgICAgICAgIC5wLWRhdGVwaWNrZXItbmV4dCB7XG4gICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7IC8vIE9jdWx0YXIgbmF2ZWdhY2nDs24geWEgcXVlIHRlbmVtb3MgdmlzdGEgZmlqYSBwb3IgbWVzXG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA3NjhweCkge1xuICAuaG9saWRheXMtZGlhbG9nIHtcbiAgICB3aWR0aDogMTAwdnc7XG4gICAgaGVpZ2h0OiAxMDB2aDtcbiAgICBtYXJnaW46IDA7XG5cbiAgICAucC1kaWFsb2ctY29udGVudCB7XG4gICAgICBwYWRkaW5nOiAwLjVyZW07XG4gICAgfVxuXG4gICAgLmhvbGlkYXlzLWNhbGVuZGFyLWdyaWQge1xuICAgICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxZnI7XG4gICAgICBnYXA6IDFyZW07XG5cbiAgICAgIC5tb250aC1jYWxlbmRhciB7XG4gICAgICAgIC5ob2xpZGF5LWNhbGVuZGFyIHtcbiAgICAgICAgICAucC1kYXRlcGlja2VyIHtcbiAgICAgICAgICAgIHRhYmxlIHtcbiAgICAgICAgICAgICAgdGQgPiBzcGFuIHtcbiAgICAgICAgICAgICAgICB3aWR0aDogMS43NXJlbTtcbiAgICAgICAgICAgICAgICBoZWlnaHQ6IDEuNzVyZW07XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
